module.exports = __webpack_public_path__ + "images/banners/page_lp_watch/banner_estimate_form_9815fd22449ff26bac0325faa761835a.webp";